module.exports = __webpack_public_path__ + "static/media/color4.beac3f6f.PNG";